import {
	FILEMANAGER_SEARCH_MEDIAFILE_COUNT,
	FILEMANAGER_SEARCH_MEDIAFILES_COUNT_SUCCESS,
	FILEMANAGER_SEARCH_MEDIAFILES_COUNT_FAIL,
	FETCH_LIGHTBOXDETAILS,
	FETCH_LIGHTBOXDETAILS_SUCCESS,
	FETCH_LIGHTBOXDETAILS_FAILED,
} from 'redux/actions';
const initState = {
	user: {
		countOfTodaysFile: 0,
	},
};

function generalData(state = initState, action) {
	switch (action.type) {
		case FILEMANAGER_SEARCH_MEDIAFILE_COUNT:
			return {
				...state,
			};
		case FILEMANAGER_SEARCH_MEDIAFILES_COUNT_SUCCESS:
			return {
				...state,
				user: { ...state.user, countOfTodaysFile: action.result.data.totalFound },
			};
		case FILEMANAGER_SEARCH_MEDIAFILES_COUNT_FAIL:
			return {
				...state,
			};
		case FETCH_LIGHTBOXDETAILS:
			return {
				...state,
			};
		case FETCH_LIGHTBOXDETAILS_SUCCESS:
			return {
				...state,
				user: { ...state.user, lightboxDetails: action.result.data },
			};
		case FETCH_LIGHTBOXDETAILS_FAILED:
			return {
				...state,
			};
		default:
			return state;
	}
}

export default generalData;
